(() => {
  document.querySelectorAll('[data-pk-test]').forEach(async root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const canvas = root.querySelector('canvas'), status = root.querySelector('.pk-status');
    const editor=root.querySelector('.pk-editor'), opener=root.querySelector('[data-customise]');
    opener.addEventListener('click',()=>{
      root.querySelector('[data-editor-stage]').appendChild(canvas);
      editor.style.setProperty('--pk-header-height', `${document.querySelector('.site-header')?.getBoundingClientRect().bottom || 96}px`);
      editor.show();
      root.querySelector('[data-done]').focus({preventScroll:true});
      editor.querySelector('.pk-layout').scrollTop=0;
      requestAnimationFrame(()=>window.dispatchEvent(new Event('resize')));
    });
    editor.addEventListener('keydown',event=>{if(event.key==='Escape')editor.close();});
    root.querySelector('[data-edit-saved]').addEventListener('click',()=>opener.click());
    editor.addEventListener('close',()=>{
      
      opener.focus();
      requestAnimationFrame(()=>window.dispatchEvent(new Event('resize')));
    });
    const gallery=root.querySelector('[data-gallery]');
    function galleryIndex(){return Math.round(gallery.scrollLeft/gallery.clientWidth);}
    function moveGallery(delta){gallery.scrollTo({left:gallery.clientWidth*((galleryIndex()+delta+3)%3),behavior:'smooth'});}
    root.querySelector('[data-pk-prev]').addEventListener('click',()=>moveGallery(-1));
    root.querySelector('[data-pk-next]').addEventListener('click',()=>moveGallery(1));
    gallery.addEventListener('scroll',()=>root.querySelector('[data-pk-current]').textContent=String(galleryIndex()+1),{passive:true});
    root.pkPhotoDesign=null;
    root.pkOriginalDesign=()=>{
      const selection={front:'#b99a54',back:'#b99a54',left:'#24282d',right:'#24282d',top:'#b99a54',bottom:'#24282d'};
      const atlas=document.createElement('canvas');atlas.width=1536;atlas.height=1024;const ctx=atlas.getContext('2d');
      Object.values(selection).forEach((colour,i)=>{ctx.fillStyle=colour;ctx.fillRect(i%3*512,Math.floor(i/3)*512,512,512);});
      return {atlas:atlas.toDataURL('image/png'),selection,lights:true,artwork:{}};
    };
    let gl;
    try {
      gl = canvas.getContext('webgl', {alpha:true, antialias:true, preserveDrawingBuffer:true});
      if (!gl) throw Error('WebGL unavailable');
      const response = await fetch(root.dataset.src);
      if (!response.ok) throw Error('Model download failed');
      const data = await response.arrayBuffer(), dv = new DataView(data);
      if(dv.getUint32(0,true)!==0x46546c67 || dv.getUint32(4,true)!==2) throw Error('Invalid GLB');
      let doc, binary;
      for(let p=12;p<data.byteLength;){
        const length=dv.getUint32(p,true), type=dv.getUint32(p+4,true);
        if(type===0x4e4f534a) doc=JSON.parse(new TextDecoder().decode(new Uint8Array(data,p+8,length)));
        if(type===0x004e4942) binary=new DataView(data,p+8,length);
        p+=8+length;
      }
      const faceNames=["back_lower", "sleeve_right_front", "sleeve_left_front", "back_upper", "sleeve_right_back", "front_upper_right", "collar", "hood_centre", "hood_left", "hood_right", "sleeve_left_back", "front_lower_left", "front_lower_right", "front_upper_left", "waistband", "cuff_right", "cuff_left"];
      const panelGroups=faceNames.map((_,i)=>i);
      function read(index){
        const a=doc.accessors[index],v=doc.bufferViews[a.bufferView];
        const size={SCALAR:1,VEC2:2,VEC3:3,VEC4:4}[a.type];
        const bytes={5121:1,5123:2,5125:4,5126:4}[a.componentType];
        const out=new Float32Array(a.count*size);
        for(let i=0;i<a.count;i++)for(let j=0;j<size;j++){
          const at=(v.byteOffset||0)+(a.byteOffset||0)+i*(v.byteStride||size*bytes)+j*bytes;
          out[i*size+j]=a.componentType===5126?binary.getFloat32(at,true):a.componentType===5125?binary.getUint32(at,true):a.componentType===5123?binary.getUint16(at,true):binary.getUint8(at);
        }
        return out;
      }
      const draws=[];
      const low=[Infinity,Infinity,Infinity],high=[-Infinity,-Infinity,-Infinity];
      doc.meshes.forEach((mesh,i)=>mesh.primitives.forEach(p=>{
        const pos=read(p.attributes.POSITION),norm=read(p.attributes.NORMAL),uv=read(p.attributes.TEXCOORD_0);
        for(let j=0;j<pos.length;j++) {low[j%3]=Math.min(low[j%3],pos[j]);high[j%3]=Math.max(high[j%3],pos[j]);}
        draws.push({pos,norm,uv,indices:read(p.indices),avatar:!!mesh.extras?.avatar,detail:!!mesh.extras?.detail,group:mesh.extras?.panelGroup??(mesh.extras?.avatar?-1:panelGroups[Math.floor(i/2)]),ledGroup:mesh.extras?.ledGroup??(mesh.extras?.avatar?-1:panelGroups[Math.floor(i/2)]),graphic:mesh.extras?.graphic??(!mesh.extras?.avatar&&i%2===1),material:doc.materials[p.material]});
      }));
      draws.forEach(d=>{
        let u0=Infinity,v0=Infinity,u1=-Infinity,v1=-Infinity;
        for(let i=0;i<d.uv.length;i+=2){u0=Math.min(u0,d.uv[i]);u1=Math.max(u1,d.uv[i]);v0=Math.min(v0,d.uv[i+1]);v1=Math.max(v1,d.uv[i+1]);}
        const span=Math.max(u1-u0,v1-v0,.000001);
        d.uvBounds=[(u0+u1-span)/2,(v0+v1-span)/2,span,span];
      });
      const center=low.map((n,i)=>(n+high[i])/2),scale=1.65/Math.max(...high.map((n,i)=>n-low[i]));
      function shader(type,source){const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error(gl.getShaderInfoLog(s));return s;}
      const program=gl.createProgram();
      gl.attachShader(program,shader(gl.VERTEX_SHADER,`
        attribute vec3 position;attribute vec3 normal;attribute vec2 texcoord;
        uniform vec2 angles;uniform vec2 framing;
        varying vec3 direction;varying vec3 point;varying vec2 originalUV;
        vec3 rotate(vec3 p){float c=cos(angles.x),s=sin(angles.x);p=vec3(c*p.x+s*p.z,p.y,-s*p.x+c*p.z);c=cos(angles.y);s=sin(angles.y);return vec3(p.x,c*p.y-s*p.z,s*p.y+c*p.z);}
        void main(){vec3 p=rotate(position);gl_Position=vec4(p.x*framing.x,p.y*framing.y,-p.z*.5,1.);direction=rotate(normal);point=position;originalUV=texcoord;}
      `));
      gl.attachShader(program,shader(gl.FRAGMENT_SHADER,`
        precision mediump float;
        uniform sampler2D atlas;uniform sampler2D originalTexture;uniform float lightsOn;uniform float referenceCapture;uniform float group;uniform float ledGroup;uniform float textured;uniform float custom;uniform float graphic;uniform float picking;
        uniform vec4 baseColour;uniform vec4 uvTransform;uniform vec4 panelBounds;uniform vec4 modelCoordinates;
        varying vec3 direction;varying vec3 point;varying vec2 originalUV;
        // Physical module: 4 columns x 10 rows, 6 mm pitch, embedded behind the fabric.
        // Coordinates are CLO metres so zoom cannot change the module/garment ratio.
        float ledDistance(vec2 p){
          vec2 cell=clamp(floor(p/.006+vec2(2.,5.)),vec2(0.),vec2(3.,9.));
          vec2 delta=abs(p-(cell+vec2(.5)-vec2(2.,5.))*.006)-vec2(.001875);
          return length(max(delta,vec2(0.)))+min(max(delta.x,delta.y),0.);
        }
        vec2 ledModule(vec2 p){
          vec2 edge=abs(p)-vec2(.01275,.03075);
          float backing=1.-smoothstep(0.,.0007,max(edge.x,edge.y));
          return vec2(ledDistance(p),backing);
        }
        void main(){
          if(picking>.5){gl_FragColor=vec4((group+1.)/255.,0.,0.,1.);return;}
          if(graphic>.5&&custom>.5)discard;
          vec2 uv=(originalUV-panelBounds.xy)/panelBounds.zw;
          uv=clamp(uv,vec2(.002),vec2(.998));
          vec4 colour=baseColour;
          if(textured>.5)colour*=texture2D(originalTexture,fract(originalUV*uvTransform.zw+uvTransform.xy));
          if(custom>.5){vec2 cell=vec2(mod(group,5.),floor(group/5.));colour=texture2D(atlas,(cell+vec2(uv.x,1.-uv.y))/vec2(5.,4.));}
          float light=.62+.38*abs(dot(normalize(direction),normalize(vec3(-.5,1.,1.5))));
          vec2 garment=(point/modelCoordinates.w+modelCoordinates.xyz).xy;
          float nearest=10.,backing=0.;
          // Only upper-body panels: 2 front + 4 back + 4 on each outer sleeve.
          // Lower front/back, hood and neckband deliberately have no LED modules.
          if(ledGroup==5.||ledGroup==13.){
            float side=ledGroup==5.?-1.:1.;
            vec2 delta=garment-vec2(side*.055,1.425);
            vec2 m=ledModule(vec2(dot(delta,vec2(.8191520,side*.5735764)),dot(delta,vec2(-side*.5735764,.8191520))));nearest=m.x;backing=m.y;
          }
          if(ledGroup==3.){
            for(int column=0;column<2;column++)for(int row=0;row<2;row++){
              float side=column==0?-1.:1.;
              vec2 delta=garment-vec2(side*(row==0?.115:.065),1.24+float(row)*.12);
              vec2 m=ledModule(vec2(dot(delta,vec2(.923,side*.385)),dot(delta,vec2(-side*.385,.923))));
              nearest=min(nearest,m.x);backing=max(backing,m.y);
            }
          }
          if(ledGroup==4.||ledGroup==10.){
            float side=ledGroup==4.?-1.:1.;
            vec2 along=vec2(side*.6,-.8),across=vec2(.8,side*.6);
            for(int module=0;module<4;module++){
              // Two upper-arm modules and two lower-arm modules per sleeve.
              float t=module==0?.13:module==1?.22:module==2?.43:.51;
              vec2 delta=garment-(vec2(side*.15,1.48)+along*t);
              vec2 m=ledModule(vec2(dot(delta,across),dot(delta,-along)));
              nearest=min(nearest,m.x);backing=max(backing,m.y);
            }
          }
          float halo=exp(-pow(max(nearest,0.),2.)/.000006)*.30;
          float core=1.-smoothstep(-.00015,.00065,nearest);
          vec3 fabric=colour.rgb*light*mix(1.,.68,lightsOn*(1.-referenceCapture));
          // The discrete rectangular pixels remain visible when zoomed in;
          // restrained white bloom merges naturally at normal viewing distance.
          vec3 result=fabric;
          result+=lightsOn*vec3(.86,.94,1.)*halo;
          result=mix(result,vec3(1.,.99,.96),core*lightsOn);
          gl_FragColor=vec4(result,mix(colour.a,1.,core*lightsOn));
        }
      `));
      gl.linkProgram(program);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('Shader link failed');gl.useProgram(program);
      gl.uniform4f(gl.getUniformLocation(program,'modelCoordinates'),...center,scale);
      for(const d of draws){
        d.buffers={};const attributes={position:[],normal:[],texcoord:[]};
        for(const i of d.indices){for(let k=0;k<3;k++){attributes.position.push((d.pos[i*3+k]-center[k])*scale);attributes.normal.push(d.norm[i*3+k]);}attributes.texcoord.push(d.uv[i*2],d.uv[i*2+1]);}
        d.count=d.indices.length;
        for(const [name,values] of Object.entries(attributes)){const b=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(values),gl.STATIC_DRAW);d.buffers[name]=b;}
      }
      const textureAssets=await Promise.all(doc.images.map(async image=>{
        const view=doc.bufferViews[image.bufferView];
        const bytes=new Uint8Array(binary.buffer,binary.byteOffset+(view.byteOffset||0),view.byteLength);
        const url=URL.createObjectURL(new Blob([bytes],{type:image.mimeType}));
        let bitmap;
        try{bitmap=await new Promise((resolve,reject)=>{const im=new Image();im.onload=()=>resolve(im);im.onerror=reject;im.src=url;});}finally{URL.revokeObjectURL(url);}
        const texture=gl.createTexture();gl.activeTexture(gl.TEXTURE1);gl.bindTexture(gl.TEXTURE_2D,texture);
        gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
        gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,bitmap);return {bitmap,texture};
      }));
      const originalImage=textureAssets[0].bitmap;
      gl.uniform1i(gl.getUniformLocation(program,'originalTexture'),1);gl.activeTexture(gl.TEXTURE0);
      gl.enable(gl.DEPTH_TEST);gl.enable(gl.BLEND);gl.blendFunc(gl.SRC_ALPHA,gl.ONE_MINUS_SRC_ALPHA);
      const customised=new Set();
      let picking=false;
      function drawModel(){
        gl.uniform1f(gl.getUniformLocation(program,'picking'),picking?1:0);
        for(const d of [...draws.filter(d=>!d.graphic),...draws.filter(d=>d.graphic)]){
          if(picking&&d.graphic)continue;
          for(const [name,b] of Object.entries(d.buffers)){gl.bindBuffer(gl.ARRAY_BUFFER,b);const loc=gl.getAttribLocation(program,name);gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,name==='texcoord'?2:3,gl.FLOAT,false,0,0);}
          const mat=d.material.pbrMetallicRoughness,t=mat.baseColorTexture?.extensions?.KHR_texture_transform;
          gl.uniform4fv(gl.getUniformLocation(program,'panelBounds'),d.uvBounds);gl.uniform1f(gl.getUniformLocation(program,'group'),d.group);gl.uniform1f(gl.getUniformLocation(program,'graphic'),d.graphic?1:0);gl.uniform1f(gl.getUniformLocation(program,'custom'),customised.has(faceNames[d.group])?1:0);
          const asset=mat.baseColorTexture?textureAssets[doc.textures[mat.baseColorTexture.index].source]:null;
          gl.uniform1f(gl.getUniformLocation(program,'textured'),asset?1:0);gl.uniform1f(gl.getUniformLocation(program,'ledGroup'),d.ledGroup);
          if(asset){gl.activeTexture(gl.TEXTURE1);gl.bindTexture(gl.TEXTURE_2D,asset.texture);gl.activeTexture(gl.TEXTURE0);}
          gl.uniform4fv(gl.getUniformLocation(program,'baseColour'),mat.baseColorFactor||[1,1,1,1]);gl.uniform4f(gl.getUniformLocation(program,'uvTransform'),...(t?.offset||[0,0]),...(t?.scale||[1,1]));
          gl.depthMask(!d.graphic);gl.drawArrays(gl.TRIANGLES,0,d.count);
        }
        gl.depthMask(true);
      }
      let yaw=.2,pitch=.05,zoom=1;
      const lightsOption=root.querySelector('[data-add-lights]'),lightsPreview=root.querySelector('[data-preview-lights]');
      const lightsLoc=gl.getUniformLocation(program,'lightsOn');
      function updatePrice(){
        const customPhoto=Object.values(artwork).some(art=>art.type==='photo');
        const total=400+(lightsOption.checked?150:0)+(customPhoto?150:0);
        root.querySelectorAll('[data-total]').forEach(node=>node.textContent='£'+total);
        root.querySelector('[data-photo-charge]').hidden=!customPhoto;
        lightsPreview.disabled=!lightsOption.checked;
      }

      const angleLoc=gl.getUniformLocation(program,'angles'), frameLoc=gl.getUniformLocation(program,'framing');
      const defaults=Object.fromEntries(faceNames.map(name=>[name,'#b99a54']));
      const selection={...defaults};
      const artwork={};
      const atlas=document.createElement('canvas');atlas.width=2560;atlas.height=2048;
      const atlasContext=atlas.getContext('2d');
      const texture=gl.createTexture();gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,texture);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
      gl.uniform1i(gl.getUniformLocation(program,'atlas'),0);
      const tartan=document.createElement('canvas');tartan.width=tartan.height=512;
      const tc=tartan.getContext('2d');tc.fillStyle='#b99a54';tc.fillRect(0,0,512,512);
      for(let a=0;a<512;a+=128){
        tc.fillStyle='#24282d';tc.fillRect(a,0,46,512);tc.fillRect(0,a,512,46);
        tc.fillStyle='#e7d6a6';tc.fillRect(a+67,0,5,512);tc.fillRect(0,a+67,512,5);
        tc.fillStyle='#756036';tc.fillRect(a+90,0,12,512);tc.fillRect(0,a+90,512,12);
      }
      root.querySelector('[data-pattern-thumb]').src=tartan.toDataURL();
      const originalThumb=document.createElement('canvas');originalThumb.width=originalThumb.height=64;originalThumb.getContext('2d').drawImage(originalImage,0,0,64,64);root.querySelector('[data-original-thumb]').src=originalThumb.toDataURL();
      function renderAtlas(){
        Object.keys(defaults).forEach((face,index)=>{
          const left=index%5*512,top=Math.floor(index/5)*512,art=artwork[face];
          atlasContext.save();atlasContext.beginPath();atlasContext.rect(left,top,512,512);atlasContext.clip();
          atlasContext.fillStyle=selection[face];atlasContext.fillRect(left,top,512,512);
          if(!customised.has(face)){
            atlasContext.fillStyle='#090099';atlasContext.fillRect(left,top,512,512);
            atlasContext.globalAlpha=.38;atlasContext.drawImage(originalImage,left,top,512,512);atlasContext.globalAlpha=1;
          }
          if(art){
            const img=art.type==='pattern'?tartan:art.image;
            const width=img.naturalWidth||img.width,height=img.naturalHeight||img.height;
            const fit=512/Math.max(width,height)*art.scale;
            atlasContext.translate(left+256+art.x*256,top+256+art.y*256);
            atlasContext.rotate(art.angle*Math.PI/180);
            atlasContext.drawImage(img,-width*fit/2,-height*fit/2,width*fit,height*fit);
          }
          atlasContext.restore();
        });
        gl.bindTexture(gl.TEXTURE_2D,texture);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,atlas);
      }
      root.pkTryTexture=()=>({atlas,lights:lightsOption.checked&&lightsPreview.checked});
      function captureDesignViews(){
        if(gl.isContextLost())throw Error('Model unavailable');
        const sheet=document.createElement('canvas');sheet.width=sheet.height=1536;
        const context=sheet.getContext('2d');
        context.fillStyle='#f5f5f2';context.fillRect(0,0,1536,1536);
        const views=[['FRONT',0],['BACK',Math.PI],["WEARER LEFT",-Math.PI/2],["WEARER RIGHT",Math.PI/2]];
        try{
          canvas.width=canvas.height=768;gl.viewport(0,0,768,768);
          gl.uniform1f(lightsLoc,lightsOption.checked?1:0);gl.uniform1f(gl.getUniformLocation(program,'referenceCapture'),1);gl.uniform2f(frameLoc,1.05,1.05);
          views.forEach(([label,angle],i)=>{
            gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
            gl.uniform2f(angleLoc,angle,0);drawModel();
            const x=i%2*768,y=Math.floor(i/2)*768;
            context.drawImage(canvas,x+16,y+32,736,736);
            context.fillStyle='#111';context.font='bold 24px sans-serif';context.textAlign='center';context.fillText(label,x+384,y+30);
          });
          const front=document.createElement('canvas');front.width=front.height=768;front.getContext('2d').drawImage(sheet,0,32,768,736,0,16,768,736);
          return {sheet:sheet.toDataURL('image/png'),front:front.toDataURL('image/png')};
        }finally{gl.uniform1f(gl.getUniformLocation(program,'referenceCapture'),0);paint();}
      }
      root.pkPhotoDesign=()=>{
        const rendered=captureDesignViews();
        const panelAtlas=document.createElement('canvas');panelAtlas.width=1280;panelAtlas.height=1024;
        panelAtlas.getContext('2d').drawImage(atlas,0,0,1280,1024);
        const legacySelection={front:selection.front_upper_right,back:selection.back_upper,left:selection.sleeve_left_front,right:selection.sleeve_right_front,top:selection.hood_centre,bottom:selection.collar};
        return {atlas:panelAtlas.toDataURL('image/png'),garmentViews:rendered.sheet,designPreview:rendered.front,selection:legacySelection,lights:lightsOption.checked,artwork:{},panelDesign:{version:4,columns:5,rows:4,order:[...faceNames],customised:[...customised],selection:{...selection},artwork:Object.fromEntries(Object.entries(artwork).map(([face,art])=>[face,{type:art.type,scale:art.scale,x:art.x,y:art.y,angle:art.angle}]))}};
      };

      function showSaved(design){
        root.pkSavedDesign=design;
        const photo=Object.values(design.panelDesign?.artwork||{}).some(art=>art.type==='photo');
        root.querySelector('[data-saved-price]').textContent='£'+(400+(design.lights?150:0)+(photo?150:0));
        root.querySelector('[data-saved-preview]').src=design.designPreview;
        root.querySelector('[data-saved-card]').hidden=false;
      }
      const removeDialog=root.querySelector('[data-remove-dialog]');
      root.querySelector('[data-remove-saved]').addEventListener('click',()=>{root.querySelector('[data-remove-error]').hidden=true;removeDialog.showModal();});
      root.querySelector('[data-keep-design]').addEventListener('click',()=>removeDialog.close());
      root.querySelector('[data-confirm-remove]').addEventListener('click',async()=>{
        const button=root.querySelector('[data-confirm-remove]');button.disabled=true;
        try{
          await persistSaved(null);
          root.pkSavedDesign=null;
          root.querySelector('[data-saved-card]').hidden=true;
          root.querySelector('[data-saved-preview]').removeAttribute('src');
          root.querySelector('[data-saved-status]').textContent='';
          customised.clear();Object.assign(selection,defaults);
          for(const face of Object.keys(artwork))delete artwork[face];
          lightsOption.checked=true;lightsPreview.checked=true;
          root.querySelector('[data-photo]').value='';
          root.querySelector('[data-upload-status]').textContent='';
          updateColours();selectFace('front_upper_left');removeDialog.close();opener.focus();
        }catch{root.querySelector('[data-remove-error]').hidden=false;}
        finally{button.disabled=false;}
      });
      function syncArtwork(){
        const art=artwork[activeFace];
        root.querySelector('.pk-image-controls').hidden=!art;
        root.querySelectorAll('[data-image-control]').forEach(input=>input.value=art?.[input.dataset.imageControl]??(input.dataset.imageControl==='scale'?1:0));
        root.querySelector('[data-original-print]').setAttribute('aria-pressed',String(!customised.has(activeFace)));
        root.querySelector('[data-pattern]').setAttribute('aria-pressed',String(art?.type==='pattern'));
      }
      function openDatabase(){
        return new Promise((resolve,reject)=>{
          const request=indexedDB.open('cc-parka-clo-panels',1);
          request.onupgradeneeded=()=>request.result.createObjectStore('designs');
          request.onsuccess=()=>resolve(request.result);request.onerror=()=>reject(request.error);
        });
      }
      async function readSaved(){
        const db=await openDatabase();
        return new Promise((resolve,reject)=>{
          const tx=db.transaction('designs'),request=tx.objectStore('designs').get('cube');
          request.onsuccess=()=>resolve(request.result);request.onerror=()=>reject(request.error);
          tx.oncomplete=()=>db.close();
        });
      }
      async function persistSaved(value){
        const db=await openDatabase();
        return new Promise((resolve,reject)=>{
          const tx=db.transaction('designs','readwrite');
          if(value)tx.objectStore('designs').put(value,'cube');else tx.objectStore('designs').delete('cube');
          tx.oncomplete=()=>{db.close();resolve();};tx.onerror=()=>{db.close();reject(tx.error);};
        });
      }
      function decodeImage(src){
        return new Promise((resolve,reject)=>{const image=new Image();image.onload=()=>resolve(image);image.onerror=reject;image.src=src;});
      }

      let activeFace='front_upper_left';
      const selector=root.querySelector('[data-panel-select]');
      const faces=[...selector.options], swatches=[...root.querySelectorAll('.pk-palette input')];
      function selectFace(face,snap=false){
        activeFace=face;
        selector.value=face;
        root.querySelector('[data-panel-count]').textContent=String(faces.findIndex(option=>option.dataset.face===face)+1)+' / '+faces.length;
        root.querySelector('[data-active-face]').textContent=faces.find(button=>button.dataset.face===face).textContent;
        swatches.forEach(input=>input.checked=customised.has(face)&&input.value===selection[face]);
        syncArtwork();
        if(snap){
          yaw=face.includes('back')?Math.PI:face.includes('hood_left')?-.65:face.includes('hood_right')?.65:0;
          pitch=face.startsWith('hood')||face==='collar'?-.15:0;

        }
        paint();
      }
      function paint(){
        root.classList.toggle('pk-lights-on',lightsOption.checked&&lightsPreview.checked);
        const rect=canvas.getBoundingClientRect(),dpr=Math.min(devicePixelRatio||1,2);
        const w=Math.max(1,Math.round(rect.width*dpr)),h=Math.max(1,Math.round(rect.height*dpr));
        if(canvas.width!==w||canvas.height!==h){canvas.width=w;canvas.height=h;}
        gl.viewport(0,0,w,h);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
        gl.uniform1f(lightsLoc,lightsOption.checked&&lightsPreview.checked?1:0);
        gl.uniform2f(angleLoc,yaw,pitch);gl.uniform2f(frameLoc,1.1*zoom*Math.min(1,h/w),1.1*zoom*Math.min(1,w/h));
        drawModel();
      }
      function updateColours(){
        const summary=[];
        for(const [face,value] of Object.entries(selection)){

          const label=!customised.has(face)?root.dataset.originalLabel:artwork[face]?(artwork[face].type==='pattern'?root.dataset.patternLabel:root.dataset.photoLabel):(swatches.find(input=>input.value===value)?.dataset.label||value);
          summary.push(faces.find(button=>button.dataset.face===face).textContent+': '+label);
        }
        renderAtlas();updatePrice();
        root.querySelector('[data-summary]').textContent=summary.join(' · ');
        root.querySelector('[data-saved-status]').textContent='';
        paint();
      }

      let restored=false;
      try{
        const saved=await readSaved();
        if(saved){restored=true;for(const face of saved.customised||[])if(faceNames.includes(face))customised.add(face);
          lightsOption.checked=saved.lights!==false;lightsPreview.checked=saved.previewLights!==false;
          for(const face of Object.keys(defaults)){
            if(swatches.some(input=>input.value===saved.selection?.[face]))selection[face]=saved.selection[face];
            const art=saved.artwork?.[face];
            if(art&&['pattern','photo'].includes(art.type)){
              artwork[face]={...art,image:art.type==='photo'?await decodeImage(art.src):null};
            }
          }
        }
      }catch{}
      root.querySelector('.pk-all').disabled=false;
      lightsOption.addEventListener('change',()=>{if(lightsOption.checked)lightsPreview.checked=true;updatePrice();paint();root.querySelector('[data-saved-status]').textContent='';});
      lightsPreview.addEventListener('change',()=>{paint();root.querySelector('[data-saved-status]').textContent='';});
      selector.addEventListener('change',()=>selectFace(selector.value,true));
      root.querySelectorAll('[data-panel-step]').forEach(button=>button.addEventListener('click',()=>{
        const index=faces.findIndex(option=>option.dataset.face===activeFace);
        selectFace(faces[(index+Number(button.dataset.panelStep)+faces.length)%faces.length].dataset.face,true);
      }));
      root.querySelector('[data-original-print]').addEventListener('click',()=>{customised.delete(activeFace);delete artwork[activeFace];syncArtwork();updateColours();selectFace(activeFace);});
      swatches.forEach(input=>input.addEventListener('change',()=>{customised.add(activeFace);selection[activeFace]=input.value;delete artwork[activeFace];syncArtwork();updateColours();}));
      root.querySelector('[data-pattern]').addEventListener('click',()=>{
        customised.add(activeFace);artwork[activeFace]={type:'pattern',scale:1,x:0,y:0,angle:0};syncArtwork();updateColours();
      });
      root.querySelectorAll('[data-image-control]').forEach(input=>input.addEventListener('input',()=>{
        if(artwork[activeFace]){artwork[activeFace][input.dataset.imageControl]=Number(input.value);updateColours();}
      }));
      root.querySelector('[data-clear-image]').addEventListener('click',()=>{delete artwork[activeFace];syncArtwork();updateColours();});
      root.querySelector('[data-photo]').addEventListener('change',async event=>{
        const file=event.target.files[0],face=activeFace;
        if(!file)return;
        const message=root.querySelector('[data-upload-status]');
        let url;
        try{
          if(file.size>20*1024*1024)throw Error('Image too large');
          message.textContent=root.dataset.uploadLoading;
          url=URL.createObjectURL(file);
          const image=await decodeImage(url),resized=document.createElement('canvas');
          const ratio=Math.min(1,1600/Math.max(image.naturalWidth,image.naturalHeight));
          resized.width=Math.max(1,Math.round(image.naturalWidth*ratio));resized.height=Math.max(1,Math.round(image.naturalHeight*ratio));
          resized.getContext('2d').drawImage(image,0,0,resized.width,resized.height);
          const src=resized.toDataURL('image/png');
          customised.add(face);artwork[face]={type:'photo',src,image:resized,scale:1,x:0,y:0,angle:0};
          syncArtwork();updateColours();message.textContent=root.dataset.uploadReady;
        }catch{message.textContent=root.dataset.uploadError;}
        finally{if(url)URL.revokeObjectURL(url);event.target.value='';}
      });
      root.querySelector('[data-save]').addEventListener('click',async()=>{
        try{
          const savedArt=Object.fromEntries(Object.entries(artwork).map(([face,art])=>{const {image,...data}=art;return [face,data];}));
          const design=root.pkPhotoDesign();
          await persistSaved({customised:[...customised],selection:{...selection},artwork:savedArt,lights:lightsOption.checked,previewLights:lightsPreview.checked});
          showSaved(design);
          root.querySelector('[data-editor-save-status]').textContent='';
          root.querySelector('[data-saved-status]').textContent=root.dataset.saved;
          editor.close();
        }catch{root.querySelector('[data-editor-save-status]').textContent=root.dataset.saveError;}
      });
      root.querySelectorAll('[data-turn]').forEach(button=>button.addEventListener('click',()=>{yaw+=Number(button.dataset.turn)*Math.PI/4;paint();}));
      root.querySelector('[data-zoom]').addEventListener('input',event=>{zoom=Number(event.target.value);paint();});
      root.querySelector('[data-reset]').addEventListener('click',()=>{yaw=.2;pitch=.05;zoom=1;root.querySelector('[data-zoom]').value='1';paint();});
      root.querySelector('[data-reset-design]').addEventListener('click',()=>{
        if(!window.confirm(root.querySelector('[data-reset-design]').dataset.confirm))return;
        lightsOption.checked=true;lightsPreview.checked=true;customised.clear();Object.assign(selection,defaults);
        for(const face of Object.keys(artwork))delete artwork[face];
        root.querySelector('[data-photo]').value='';
        root.querySelector('[data-upload-status]').textContent='';
        updateColours();selectFace('front_upper_left');paint();
      });
      let drag;
      canvas.addEventListener('pointerdown',event=>{
        if(event.pointerType==='mouse' && event.button!==0)return;
        event.preventDefault();drag={id:event.pointerId,x:event.clientX,y:event.clientY,startX:event.clientX,startY:event.clientY};canvas.setPointerCapture(event.pointerId);
      });
      canvas.addEventListener('pointermove',event=>{
        if(!drag||event.pointerId!==drag.id)return;
        event.preventDefault();yaw+=(event.clientX-drag.x)*.018;pitch+=(event.clientY-drag.y)*.018;
        drag.x=event.clientX;drag.y=event.clientY;paint();
      });
      function pickFace(event){
        const rect=canvas.getBoundingClientRect();picking=true;gl.disable(gl.BLEND);gl.disable(gl.DITHER);paint();
        const pixel=new Uint8Array(4);gl.readPixels(Math.floor((event.clientX-rect.left)/rect.width*canvas.width),Math.floor((rect.bottom-event.clientY)/rect.height*canvas.height),1,1,gl.RGBA,gl.UNSIGNED_BYTE,pixel);
        picking=false;gl.enable(gl.BLEND);gl.enable(gl.DITHER);if(pixel[0]>=1&&pixel[0]<=faceNames.length)selectFace(faceNames[pixel[0]-1]);paint();
      }

      canvas.addEventListener('pointerup',event=>{
        if(drag&&Math.hypot(event.clientX-drag.startX,event.clientY-drag.startY)<7)pickFace(event);
        drag=null;
      });
      for(const event of ['pointercancel','lostpointercapture'])canvas.addEventListener(event,()=>drag=null);
      canvas.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key))return;
        event.preventDefault();
        if(event.key==='ArrowLeft')yaw-=.2;if(event.key==='ArrowRight')yaw+=.2;
        if(event.key==='ArrowUp')pitch=Math.max(-1.4,pitch-.2);if(event.key==='ArrowDown')pitch=Math.min(1.4,pitch+.2);paint();
      });
      canvas.addEventListener('webglcontextlost',event=>{event.preventDefault();status.textContent=root.dataset.error;root.querySelector('.pk-all').disabled=true;});
      new ResizeObserver(paint).observe(canvas);
      updateColours();selectFace('front_upper_left');status.textContent=root.dataset.ready;
      root.querySelector('[data-save]').disabled=false;
      if(restored)showSaved(root.pkPhotoDesign());
    }catch(error){
      status.textContent=root.dataset.error;root.querySelector('.pk-all').disabled=true;console.error('Parka preview:',error);
    }
  });
})();




